import React from "react";

const EditIcon = (props: any) => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.25 17.0625H6.75C2.6775 17.0625 0.9375 15.3225 0.9375 11.25V6.75C0.9375 2.6775 2.6775 0.9375 6.75 0.9375H8.25C8.5575 0.9375 8.8125 1.1925 8.8125 1.5C8.8125 1.8075 8.5575 2.0625 8.25 2.0625H6.75C3.2925 2.0625 2.0625 3.2925 2.0625 6.75V11.25C2.0625 14.7075 3.2925 15.9375 6.75 15.9375H11.25C14.7075 15.9375 15.9375 14.7075 15.9375 11.25V9.75C15.9375 9.4425 16.1925 9.1875 16.5 9.1875C16.8075 9.1875 17.0625 9.4425 17.0625 9.75V11.25C17.0625 15.3225 15.3225 17.0625 11.25 17.0625Z"
        fill="var(--color-icon-bright)"
      />
      <path
        d="M6.37549 13.2674C5.91799 13.2674 5.49799 13.1024 5.19049 12.8024C4.82299 12.4349 4.66549 11.9024 4.74799 11.3399L5.07049 9.08242C5.13049 8.64742 5.41549 8.08492 5.72299 7.77742L11.633 1.86742C13.1255 0.374922 14.6405 0.374922 16.133 1.86742C16.9505 2.68492 17.318 3.51742 17.243 4.34992C17.1755 5.02492 16.8155 5.68492 16.133 6.35992L10.223 12.2699C9.91549 12.5774 9.35299 12.8624 8.91799 12.9224L6.66049 13.2449C6.56299 13.2674 6.46549 13.2674 6.37549 13.2674ZM12.428 2.66242L6.51799 8.57242C6.37549 8.71492 6.21049 9.04492 6.18049 9.23992L5.85799 11.4974C5.82799 11.7149 5.87299 11.8949 5.98549 12.0074C6.09799 12.1199 6.27799 12.1649 6.49549 12.1349L8.75299 11.8124C8.94799 11.7824 9.28549 11.6174 9.42049 11.4749L15.3305 5.56492C15.818 5.07742 16.073 4.64242 16.1105 4.23742C16.1555 3.74992 15.9005 3.23242 15.3305 2.65492C14.1305 1.45492 13.3055 1.79242 12.428 2.66242Z"
        fill="var(--color-icon-bright)"
      />
      <path
        d="M14.8877 7.3727C14.8352 7.3727 14.7827 7.3652 14.7377 7.3502C12.7652 6.7952 11.1977 5.2277 10.6427 3.2552C10.5602 2.9552 10.7327 2.6477 11.0327 2.5577C11.3327 2.4752 11.6402 2.6477 11.7227 2.9477C12.1727 4.5452 13.4402 5.8127 15.0377 6.2627C15.3377 6.3452 15.5102 6.6602 15.4277 6.9602C15.3602 7.2152 15.1352 7.3727 14.8877 7.3727Z"
        fill="var(--color-icon-bright)"
      />
    </svg>
  );
};

export default EditIcon;
